import React from 'react';
import PropTypes from 'prop-types';
import Img from 'react-image';

/**
 * https://www.npmjs.com/package/react-image
 * @src    : Image path or path array
 * @loader : Show a "spinner" or other element before the image is loaded
 * @loader : Show a fallback element if none of the images could be loaded
 */

const Image = props => {
  const { src, loader, error, className } = props;

  return <Img
    src={ src }
    className={ className }
    loader={ loader }
    unloader={ error }
    alt="Bilyoner"
    container={ children => {
      return <div className="image-container">{ children }</div>;
    } }
    { ...props }
  />;
};

Image.propTypes = {
  src: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  loader: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default Image;
